import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameLogic } from '../Logic/ExchangeLogic';
import { ExchangeModel, ExchangeMoneyEnum, ExchangeStateEnum } from '../Models/ExchangeModel';
import { MoneyController } from './MoneyController';
import { AnimationContents } from '../../../../../../AnimationContents';
import { shuffleArray } from '../../../../../Common/Utils';
import { MoneyModel } from '../Models/MoneyModel';
import { BoxController } from './BoxController';

export class ExchangeController extends AnimationBaseController {
    $model: ExchangeModel;

    private _width: number = 0;
    private _height: number = 0;

    private _screenWidth: number = 0;
    private _screenHeight: number = 0;
    private _screenScale: number = 1;

    private _currItem: ExchangeMoneyEnum = ExchangeMoneyEnum.empty;

    private _items: any = [];
    private _itemsCount: number = 4;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('CurrencyExchange');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.EXCHANGE_JSON,
            libraryName: 'mini_game_3_container',
            childControllers: {
                BoxController: {
                    instanceName: 'mini_game_3',
                    view: BoxController,
                    model: this.$model,
                },
            },
            modelWatch: {
                state: (state: ExchangeStateEnum) => {
                    this._updateState();

                    if (state === ExchangeStateEnum.close) {
                        const moneyState = this.$childControllers.get(`mini_game_3.mini_game_3_open`).$model.state;

                        if (moneyState === this._items[this._items.length - 1]) {
                            this._options.onComplete();

                        } else {
                            for (let i = 1; i < this._items.length; i++) {
                                this.$childControllers.get(`item_${this._items[i]}`).$model.selected = false;
                            }

                            if (this.$childControllers.get(`item_${moneyState}`)) {
                                this.$childControllers.get(`item_${moneyState}`).$model.interactive = false;
                            }

                            this.$childControllers.get(`mini_game_3.mini_game_3_open`).$model.state = this._items[0];
                            this.$queue.get('openAfterFailed').addToQueue()
                        }
                    }
                },
            },
            queue: {
                openAfterFailed: {
                    condition: (time) => time > 0.3,
                    action: () => {
                        this.$model.state = ExchangeStateEnum.open;
                    },
                },
                onComplete: {
                    condition: (time) => time > 0.3,
                    action: () => {
                        if (this._options) {
                            this._options.onComplete();
                        }
                    },
                },
            },
        };
    }

    private _updateState() {
        this.gotoAndStopByQuery('mini_game_3', this.$model.state, false);
    }

    protected onInitialize(): void {
        this._updateState();

        this._width = this.display.width;
        this._height = this.display.height;

        const items = shuffleArray([
            ExchangeMoneyEnum.rub,
            ExchangeMoneyEnum.usd,
            ExchangeMoneyEnum.eur,
            ExchangeMoneyEnum.jpy,
        ]);

        this._items = items;

        this._items.forEach((o, index) => {
            if (index === 0) {
                this.addChildController({
                    instanceName: 'mini_game_3.mini_game_3_open',
                    view: MoneyController,
                    model: new MoneyModel(o),
                }, 'mini_game_3.mini_game_3_open');

            } else {
                this.addChildController({
                    instanceName: `item${index - 1}`,
                    view: MoneyController,
                    model: new MoneyModel(o),
                    options: {
                        onSelected: (state) => {
                            if (this.$model.state === ExchangeStateEnum.open) {
                                if (!this.$childControllers.get(`item_${state}`).$model.selected) {
                                    for (let i = 1; i < this._items.length; i++) {
                                        this.$childControllers.get(`item_${this._items[i]}`).$model.selected = false;
                                    }

                                    this.$childControllers.get(`item_${state}`).$model.selected = true;
                                    this.$childControllers.get(`mini_game_3.mini_game_3_open`).$model.state = state;

                                } else {
                                    for (let i = 1; i < this._items.length; i++) {
                                        this.$childControllers.get(`item_${this._items[i]}`).$model.selected = false;
                                    }

                                    this.$childControllers.get(`item_${state}`).$model.selected = false;
                                    this.$childControllers.get(`mini_game_3.mini_game_3_open`).$model.state =  this._items[0];
                                }
                            }
                        },
                    },
                }, `item_${o}`);
            }
        });

        this.gotoAndStopByQuery('change_item0', this._items[0], false);
        this.gotoAndStopByQuery('change_item1', this._items[this._items.length - 1], false);
    }

    protected onResize(width: number, height: number, scale: number) {
        this._screenWidth = width;
        this._screenHeight = height;
        this._screenScale = scale;

        this.updateScale();
    }

    protected onLandscape(): void {
        this.updateScale();
    }

    protected onPortrait(): void {
        this.updateScale();
    }

    private updateScale(): void {
        this.display.scale.set(Math.min(this._screenWidth / this._width / this._screenScale, this._screenHeight / this._height / this._screenScale * 0.6));
    }
}
